import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../../../features/home/redux/actions';
import CollectionDetail from '../collections/CollectionDetail';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
export class CollectionTab extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  state = {
    collectionsBySearch: [],
    searchKey: '',
    showLoader: false,
    expandedSections: ['SYSTEM'],
  };

  componentDidMount() {
    const { version, projectId, actions } = this.props;
    actions.loadEditorCollections({ projectId, version });
  }

  handleRefresh() {
    this.setState({ showLoader: true });
    const { version, projectId, actions } = this.props;
    actions
      .loadEditorCollections({ projectId, version })
      .then(() => this.setState({ showLoader: false }));
  }

  filterCollectionBySearch = (event) => {
    const { value } = event.target;
    const { home } = this.props;
    const { collections = [] } = home;
    const filteredCollections = value
      ? findBySearchString('collectionTitle', value, collections)
      : collections;
    const expandedSections = [];
    if (filteredCollections.some((collection) => collection.isPluginCollection))
      expandedSections.push('SYSTEM');
    if (filteredCollections.some((collection) => !collection.isPluginCollection))
      expandedSections.push('GENERAL');

    this.setState({ searchKey: value, expandedSections });
  };

  listOfCollectionsToShow = (collections) => {
    const { projectId, actions, version } = this.props;
    return collections
      .sort((a, b) => {
        return a.collectionIndex > b.collectionIndex
          ? 1
          : a.collectionIndex == b.collectionIndex
          ? 0
          : -1;
      })
      .map((collection) => (
        <CollectionDetail
          key={collection._id}
          collection={collection}
          openCollectionSetting={this.openCollectionSetting}
          openItemList={this.openItemList}
          toggleCollectionModal={actions.toggleCollectionModal}
          loadCollectionItems={actions.loadCollectionItems}
          projectId={projectId}
          version={version}
        />
      ));
  };

  showCollectionDetail = (collections) => {
    const { searchKey } = this.state;
    const filteredPages = searchKey
      ? findBySearchString('collectionTitle', searchKey, collections)
      : collections;
    return filteredPages.length > 0 ? (
      this.listOfCollectionsToShow(filteredPages)
    ) : (
      <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No matching your search.</p>
    );
  };

  renderAccordianContent = (collections) => {
    return (
      <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
        <div className="gjs-devices-c"></div>
        {this.showCollectionDetail(collections)}
      </div>
    );
  };
  renderAccordion = (collections) => {
    const accordionSections = [
      {
        Id: 'SYSTEM',
        title: 'System',
        collections: collections.filter((collection) => collection.isPluginCollection),
      },
      {
        Id: 'GENERAL',
        title: 'General',
        collections: collections.filter((collection) => !collection.isPluginCollection),
      },
    ];
    return accordionSections.map(({ Id, title, collections }) => (
      <AccordionItem key={Id} uuid={Id}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title p-2">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="p-0 mt-1">
                {collections.length === 0 ? (
                  <div>No collection available</div>
                ) : (
                  this.renderAccordianContent(collections)
                )}
              </AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };

  render() {
    const { projectId, version, home } = this.props;
    const { collections = [] } = home;
    const { showLoader, searchKey, expandedSections } = this.state;
    const totalCollectionCount = collections.length;
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Collections" className="padding-left-20">
              Collections&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'default' }}
                data-tip="Total"
                title={'Total: ' + totalCollectionCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Collections"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Collections"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title="Add Collection" className="">
              <Link
                className="btn btn-theme-submit btn-xs"
                data-tip="Add Collection"
                data-place="bottom"
                data-effect="solid"
                to={`/2.0/collections/${version}/v/${projectId}/create`}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Collection
              </Link>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div id="blocks" className="column blocks is-abs--t-l gjs-one-bg blocks-open">
          <div className="gjs-blocks-cs gjs-one-bg gjs-two-color">
            <div className="gjs-block-categories">
              <div className="gjs-pn-panel height35 width100 position-relative">
                <div className="form-outline" style={{ padding: '10px' }}>
                  <input
                    type="search"
                    className="custom-bootstrap-form-control custom-bootstrap-form-control-sm"
                    placeholder="&#xf55c; Eg: User"
                    style={{ fontFamily: 'Arial, Webconnect' }}
                    value={searchKey}
                    onChange={this.filterCollectionBySearch}
                  />
                </div>
                {showLoader ? (
                  <CustomLoader loading={showLoader} />
                ) : (
                  <Accordion
                    key={expandedSections.join(',')}
                    allowZeroExpanded
                    preExpanded={expandedSections}
                  >
                    {this.renderAccordion(collections)}
                  </Accordion>
                )}
                <hr />
              </div>
              <div className="gjs-blocks-no-cat">
                <div className="gjs-blocks-c"></div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionTab);
